export default "__VITE_ASSET__BZ2F5Uin__"